import { createStore } from 'vuex';
import cart from './modules/cart';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    cart
  }
});
